<template>
  <div class="consultation">
    <div
      v-show="!$resp.sm || currentStepIndex"
      class="consultation__nav"
    >
      <div
        v-for="(item, itemIndex) in stepItems"
        v-show="!$resp.sm"
        :key="`itemIndex-${itemIndex}`"
        class="consultation__nav-item"
        @click="itemIndex !== currentStepIndex && !disabledSteps(itemIndex) && goToStep(itemIndex)"
      >
        <span
          class="consultation__nav-item-num"
          :class="[
            itemIndex === currentStepIndex && `consultation__nav-item-num_active`,
            disabledSteps(itemIndex) && `consultation__nav-item-num_disabled`
          ]"
        >
          {{ itemIndex + 1 }}
        </span>
        {{ item }}
      </div>
      <div
        v-show="$resp.sm && currentStepIndex"
      >
        <div
          class="consultation__nav-back"
          @click="goBack()"
        >
          <span class="icon icon-chevron-left" />
          {{ _.get(pageData, 'translate.back', '') }}
        </div>
      </div>
    </div>
    <div class="container-bs">
      <h1 class="consultation__title">
        {{ pageData.title }}
      </h1>
      <div
        v-if="pageData.form"
        class="consultation__steps"
      >
        <KeepAlive>
          <Component
            :is="step"
            v-bind="pageData.form[step.toLowerCase()]"
            :defaultFields="defaultFields"
            :translate="_.get(pageData, 'translate', '')"
            :resetDefault="resetDefault"
            @nextStep="nextStep"
            @goToStep="goToStep"
            @destroy="destroy"
          />
        </KeepAlive>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import isEmpty from 'lodash/isEmpty'

  import Step1 from '../components/consultation/steps/Step1'
  import Step2 from '../components/consultation/steps/Step2'
  import Step3 from '../components/consultation/steps/Step3'

  export default {
    name: 'Consultation',

    components: {
      Step1,
      Step2,
      Step3
    },

    data () {
      return {
        defaultFields: null,
        steps: this.$route.query.dealer ? [
          'Step1',
          'Step3'
        ] : [
          'Step1',
          'Step2',
          'Step3'
        ],
        currentStepIndex: 0,
        stepItems: []
      }
    },

    computed: {
      ...mapState(
        {
          pageData: (state) => state.fleet,
          step1: state => state.consultation.step1,
          step2: state => state.consultation.step2
        }
      ),
      ...mapState(['currentLang']),

      step () {
        return this.steps[this.currentStepIndex]
      }
    },

    watch: {
      currentStepIndex: {
        handler (newVale, oldValue) {
          if (this.disabledSteps(newVale)) {
            this.goToStep(oldValue)
          }
        },
        immediate: true
      },

      pageData () {
        this.stepItems = this.$route.query.dealer ? [
          _.get(this.pageData, 'translate.step1', ''),
          _.get(this.pageData, 'translate.step2', '')
        ] : [
          _.get(this.pageData, 'translate.step1', ''),
          _.get(this.pageData, 'translate.step2', ''),
          _.get(this.pageData, 'translate.step3', '')
        ]
      },

      'pageData.form': {
        handler () {
          if (this.defaultFields === null) {
            if (this.pageData.form && this.pageData.form.step1.fields.model.items.filter(item => item.toyotaModelId === this._.get(this.$route, 'query.vehicle'))[0]) {
              setTimeout(() => {
                this.defaultFields = {
                  model: this.pageData.form.step1.fields.model.items.filter(item => item.toyotaModelId === this._.get(this.$route, 'query.vehicle'))[0],
                  engine: this._.get(this.$route, 'query.engine')
                }
              }, 100)
            }
          }
        },
        immediate: true
      }
    },

    created () {
      if (this._.get(this.$route, 'query.country')) {
        this.$store.commit('setCurrentCountry', this.$route.query.country)
      }

      if (this._.get(this.$route, 'query.lang')) {
        this.$store.commit('setCurrentLang', this.$route.query.lang)
      }
    },

    mounted () {
      if (this._.get(this.$route, 'query.vin')) {
        this.form.vin_number = this._.get(this.$route, 'query.vin')
      }
      document.body.classList.add('align-items-start')

      window.tngaDataLayer = window.tngaDataLayer || {}

      const page = {
        category: 'tools',
        subCategory: 'form',
        sectionlv1: 'forms',
        sectionlv2: 'book-dealer-appointment',
        language: _.get(this, 'currentLang', '')
      }

      const form = {
        name: 'lead-book-dealer-appointment',
        step: 'select-model',
        conversion: '0'
      }

      window.tngaDataLayer = { page, form }
    },

    methods: {
      resetDefault () {
        this.defaultFields = false
      },
      disabledSteps (index) {
        switch (index) {
        case 1:
          return isEmpty(this.step1)
        case 2:
          return isEmpty(this.step1) || isEmpty(this.step2)
        default:
          return false
        }
      },

      nextStep () {
        if (this.currentStepIndex < this.steps.length) {
          window.scrollTo(0, 0)
          this.currentStepIndex++

          const language = _.get(this, '$store.state.currentLang', '') || _.get(this, 'currentLang', '')
          const modelId = _.get(this, '$store.state.consultation.step1.modelId', '')
          const modelName = _.get(this, '$store.state.consultation.step1.modelText', '')

          if (this.currentStepIndex === 1) {
            this.pushDataToDataLayer({
              events: {
                event: {
                  name: 'formevent',
                  componentName: 'book-dealer-appointment',
                  componentGroup: 'forms',
                  action: 'form-step',
                  label: 'select-dealer'
                }
              },
              pages: {
                page: {
                  category: 'tools',
                  subCategory: 'form',
                  sectionlv1: 'forms',
                  sectionlv2: 'book-dealer-appointment',
                  language
                }
              },
              forms: {
                form: {
                  name: 'lead-book-dealer-appointment',
                  step: 'select-dealer',
                  conversion: '0'
                }
              },
              products: {
                product: [{
                  category: 'cars',
                  subCategory: 'new-cars',
                  productInfo: {
                    productId: modelId,
                    productName: modelName,
                    tmeModelId: modelId,
                    modelName
                  }
                }]
              }
            }, true)
          }

          if (this.currentStepIndex === 2) {
            this.pushDataToDataLayer({
              events: {
                event: {
                  name: 'formevent',
                  componentName: 'book-dealer-appointment',
                  componentGroup: 'forms',
                  action: 'form-step',
                  label: 'contact-details'
                }
              },
              pages: {
                page: {
                  category: 'tools',
                  subCategory: 'form',
                  sectionlv1: 'forms',
                  sectionlv2: 'book-dealer-appointment',
                  language
                }
              },
              forms: {
                form: {
                  name: 'lead-book-dealer-appointment',
                  step: 'contact-details',
                  conversion: '0'
                }
              },
              products: {
                product: [{
                  category: 'cars',
                  subCategory: 'new-cars',
                  productInfo: {
                    productId: modelId,
                    productName: modelName,
                    tmeModelId: modelId,
                    modelName
                  }
                }]
              },
              dealers: {
                dealer: {
                  name: _.get(this, '$store.state.consultation.step2.dealersText', ''),
                  dealerId: _.get(this, '$store.state.consultation.step2.dealerId', ''),
                  city: _.get(this, '$store.state.consultation.step2.dealerCity', ''),
                  zipcode: _.get(this, '$store.state.consultation.step2.dealerZipCode', '')
                }
              }
            }, true)
          }
        }
      },

      goToStep (index) {
        window.scrollTo(0, 0)
        this.currentStepIndex = index

        const language = _.get(this, '$store.state.currentLang', '') || _.get(this, 'currentLang', '')
        const modelId = _.get(this, '$store.state.consultation.step1.modelId', '')
        const modelName = _.get(this, '$store.state.consultation.step1.modelText', '')

        if (index === 0) {
          this.pushDataToDataLayer({
            events: {
              event: {
                name: 'formevent',
                componentName: 'book-dealer-appointment',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'model-selected'
              }
            },
            pages: {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-dealer-appointment',
                language
              }
            },
            forms: {
              form: {
                name: 'lead-book-dealer-appointment',
                step: 'model-selected',
                conversion: '0'
              }
            },
            products: {
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: modelId,
                  productName: modelName,
                  tmeModelId: modelId,
                  modelName
                }
              }]
            }
          }, true)
        }

        if (index === 1) {
          this.pushDataToDataLayer({
            events: {
              event: {
                name: 'formevent',
                componentName: 'book-dealer-appointment',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'select-dealer'
              }
            },
            pages: {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-dealer-appointment',
                language
              }
            },
            forms: {
              form: {
                name: 'lead-book-dealer-appointment',
                step: 'select-dealer',
                conversion: '0'
              }
            },
            products: {
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: modelId,
                  productName: modelName,
                  tmeModelId: modelId,
                  modelName
                }
              }]
            }
          }, true)
        }

        if (index === 2) {
          this.pushDataToDataLayer({
            events: {
              event: {
                name: 'formevent',
                componentName: 'book-dealer-appointment',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'contact-details'
              }
            },
            pages: {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-dealer-appointment',
                language
              }
            },
            forms: {
              form: {
                name: 'lead-book-dealer-appointment',
                step: 'contact-details',
                conversion: '0'
              }
            },
            products: {
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: modelId,
                  productName: modelName,
                  tmeModelId: modelId,
                  modelName
                }
              }]
            },
            dealers: {
              dealer: {
                name: _.get(this, '$store.state.consultation.step2.dealersText', ''),
                dealerId: _.get(this, '$store.state.consultation.step2.dealerId', ''),
                city: _.get(this, '$store.state.consultation.step2.dealerCity', ''),
                zipcode: _.get(this, '$store.state.consultation.step2.dealerZipCode', '')
              }
            }
          }, true)
        }
      },

      goBack () {
        if (this.currentStepIndex !== 0) {
          this.currentStepIndex--
        }
      },

      destroy () {
        this.$destroy()
      },

      pushDataToDataLayer (params = {}, pushDataLayer = false) {
        window.tngaDataLayer = window.tngaDataLayer || {}

        window.tngaDataLayer = { ...params.events, ...params.pages, ...params.forms, ...params.products, ...params.dealers }

        window.dataLayer = window.dataLayer || []
        if (pushDataLayer) {
          window.dataLayer.push({ 'event': 'formevent' })
        }
      }
    }
  }
</script>
<style lang="scss">
  .consultation {
    padding: 70px 0;

    .input__error-msg,
    .select__error-msg {
      width: 100%;
    }

    .container-bs {
      @media (min-width: 768px) and (max-width: 991px) {
        width: 750px;
      }
    }

    &__nav {
      display: flex;
      justify-content: center;
      margin-bottom: 36px;
      border-bottom: 1px solid $c-gray-extra-light-3;

      @include mobile() {
        justify-content: flex-start;
      }

      &-back {
        padding-bottom: 10px;
      }

      &-item {
        display: flex;
        align-items: center;
        padding: 10px 25px;

        &-num {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          margin-right: 10px;
          font-size: 16px;
          font-weight: bold;
          line-height: 27px;
          cursor: pointer;
          background: $c-gray-extra-light-3;
          border-radius: 100%;

          &_active {
            color: $c-white;
            background: $c-active;
          }

          &_disabled {
            cursor: default;
          }
        }
      }
    }

    &__title {
      font-weight: bold;
      text-align: left;

      @include mobile () {
        margin-bottom: 24px;
      }
    }

    &__wrapper {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }

    &__col {
      flex: 1 1 100%;
      max-width: 50%;
      padding: 0 15px;

      @media (max-width: 991px) {
        max-width: 100%;
      }

      &_pull-bottom-tablet {
        @media (max-width: 991px) {
          order: 1;
        }
      }

      &_w25 {
        @media (min-width: 768px) {
          max-width: 25%;
        }
      }

      &_w75 {
        @media (min-width: 768px) {
          max-width: 75%;
        }
      }

      &_w50 {
        @media (min-width: 768px) {
          max-width: 50%;
        }
      }

      &_w100 {
        max-width: 100%;
      }
    }
  }
</style>
